export default "__VITE_ASSET__DMKb0waY__"